import React from 'react';
import 'twin.macro';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import request from '@teetsh/app/src/utils/request';
import { useTranslation } from 'react-i18next';
import ButtonLink from '@teetsh/app/src/components/Buttons/Link';
import { SCHOOLS_TRASH_KEY } from './useSchoolsTrash';
import { SCHOOLS_KEY } from '@teetsh/app/src/queries/schools/useSchools';

export function useRestoreSchool() {
  const { notifySuccess, notifyError } = useNotification();
  const queryClient = useQueryClient();
  const { t } = useTranslation(['userSettings']);
  const { mutateAsync } = useMutation({
    mutationFn: ({ id, schoolyearId }: { id: string; schoolyearId: string }) =>
      request(`/schoolyears/${schoolyearId}/schools/${id}/restore`, {
        method: 'PATCH',
      }),
    onSuccess: (_, { id, schoolyearId }) => {
      queryClient.invalidateQueries({
        queryKey: [SCHOOLS_TRASH_KEY],
      });
      queryClient.invalidateQueries({
        queryKey: [SCHOOLS_KEY],
      });
      notifySuccess({
        title: t('userSettings:restore.messages.success'),
        message: (
          <ButtonLink
            outlined
            intent="success"
            to={`/mes-annees-scolaires/${schoolyearId}/ecoles/${id}`}
          >
            {t('userSettings:restore.messages.see')}
          </ButtonLink>
        ),
      });
    },
    onError: () => {
      notifyError({ title: t('userSettings:restore.messages.error') });
    },
  });
  return mutateAsync;
}
